"use client";

import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import contractImg1 from '../../assets/images/resources/contact-three-img-1.jpg';
import contractShape1 from '../../assets/images/shapes/contact-three-shape-1.png';
import '../../assets/css/contact.css';
// Define a list of services for the dropdown
const services = [
  "Choose a Option",
  "Type Of Service 01",
  "Type Of Service 02",
  "Type Of Service 03",
  "Type Of Service 04",
  "Type Of Service 05"
];

export default function ContactThree() {
  const fileInputRef = useRef(null);
  const formRef = useRef(null); // ✅ Ref for form
  const [selectedService, setSelectedService] = useState(services[0]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    uploadFile: null,
    message: "",
  });

  const [errors, setErrors] = useState({}); // ✅ Store validation errors
  const [status, setStatus] = useState(null);

  // ✅ Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // Clear errors when user starts typing
    setErrors({ ...errors, [e.target.name]: "" });
  };

    // ✅ Handle file input change
    const handleFileChange = (e) => {
    console.log("🟡 File Selected:", e.target.files[0]);
    setFormData({ ...formData, uploadFile: e.target.files[0] });
    };
  
 
  const validateForm = () => {
    let newErrors = {};
  
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }
  
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
  
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
      } else if (!/^[6789]\d{9}$/.test(formData.phone)) {
        newErrors.phone = "Enter a valid 10-digit phone number.";
      }
  
    if (!formData.message.trim()) {
      newErrors.message = "Message is required."
    }
  
    if (!formData.uploadFile) {
      newErrors.uploadFile = "Please upload a file.";
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ Return true if no errors
  };
  // ✅ Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
   
    if (!validateForm()) {
      return;
    };

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("subject", formData.subject);
    formDataToSend.append("message", formData.message);
    formDataToSend.append("uploadFile", formData.uploadFile);
    
    try {
      const response = await fetch("https://tt.sanvima.net/backend.php", {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.text();
      console.log("Server Response:", data);
      if (data.includes("Data saved successfully")) {
        setStatus({type: "success", message:"Message sent successfully!"}); // ✅ Set success message
        setFormData({ name: "", email: "", phone: "",uploadFile: null, message: "" }); // ✅ Clear form fields
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        // document.getElementById("myForm").reset();
        if (formRef.current) {
          formRef.current.reset();
        }

      } else {
        setStatus({type: "error", message:"Failed to send message."}); // ✅ Handle errors
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus({ type: "error", message: "Failed to save data."});
    }
  };


  return (
    <>
      {/* Contact Three Start */}
      <section className="contact-three">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 wow fadeInLeft" data-wow-delay="100ms">
              <div className="contact-three__left">
                <div className="section-title text-left">
                  <div className="section-title__tagline-box">
                    <span className="section-title__tagline">Get in Touch</span>
                  </div>
                  <h2 className="section-title__title">
                  Do you <span> have any questions?</span> 
                  </h2>
                </div>
                <ul className="contact-three__points list-unstyled">
                  <li>
                    <p>We’re committed to providing you with the best cybersecurity insights and solutions. Whether you’re a seasoned IT professional, a business owner, or someone just starting to explore the world of cybersecurity, we’re here to help.</p>
                  </li>
                </ul>
                <div className="footer-widget-two__social">
                     <Link to="https://www.linkedin.com/in/techtotalers-private-limited-020b0a248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><span className="icon-linkedin-in"></span></Link>
                  </div>
              </div>
            </div>
            <div className="col-xl-6 wow fadeInRight" data-wow-delay="300ms">
              <div className="contact-three__right">
                <div className="contact-three__shape-1">
                  <img src={contractShape1} alt="" />
                </div>
                <h3 className="contact-three__right-title">Contact</h3>
                <form ref={formRef} className="contact-form-validated contact-three__form" onSubmit={handleSubmit} noValidate>
                {/* <form name="myForm" id="myForm" className="contact-form-validated contact-three__form" onSubmit={handleSubmit} noValidate> */}
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Name</h4>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" />
                        <span className="error-message">{errors.name}</span>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Email</h4>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" />
                        <span className="error-message">{errors.email}</span>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <div className="contact-three__input-box">
                        <h4 className="contact-three__input-title">Phone Number</h4>
                        <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="Your Phone Number" />
                         {errors.phone && <p className="error-message">{errors.phone}</p>}
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="contact-three__input-box">
                      <h4 className="contact-three__input-title">Upload File</h4>
                      <div className="file-box">
                      <input type="file" name="uploadFile" onChange={handleFileChange} />
                      <span className="error-message">{errors.uploadFile}</span>
                      </div>
                    </div>
                    </div>
                    <div className="col-xl-12">
                      <h4 className="contact-three__input-title">Message</h4>
                      <div className="contact-three__input-box text-message-box">
                      <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Message here.."></textarea>
                      <span className="error-message">{errors.message}</span>
                      </div>
                      <div className="contact-three__btn-box-two">
                        <button type="submit" className="thm-btn-two contact-three__btn-two">
                          Submit Now<span className="icon-dubble-arrow-right"></span>
                        </button>
                      </div>
                      {status && <p className={`status-message ${status.type === "success" ? "success" : "error"}`}>{status.message}</p>}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Three End */}
    </>
  );
}
